<div class="row" *ngIf="backRedirectActionflag">
  <div class="col">
      <div class="back-link" [ngClass]="{'absolute': !filters || filters.length === 0}" (click)="goBack(backRedirectPageFormId)">&#60; Back</div>
  </div>
</div>
<div class="container-fluid">
  <p-overlayPanel #op [appendTo]="'body'">
    <ng-template pTemplate>
      <div class="fb-filter-container">
        <div class="row">
          <div class="col-6" *ngFor="let filter of filters">
            <div class="form-group">
              <label for="exampleInputEmail1">{{ filter.displayName }}</label>
              <div [ngSwitch]="filter.typeOfFilter">
                <div *ngSwitchCase="'TEXTBOX'">
                  <input type="text" class="form-control" pInputText placeholder="Enter" [(ngModel)]="filter.value">
                </div>
                <div *ngSwitchCase="'NUMBER'">
                  <input type="number" class="form-control" pInputText placeholder="Enter" [(ngModel)]="filter.value">
                  <!-- <input type="text" pattern="^[0-9]$" class="form-control" pInputText placeholder="Enter" [(ngModel)]="filter.value"> -->
                </div>

                <div *ngSwitchCase="'DROPDOWN'">
                  <p-dropdown [options]="filter.options" class="form-control" placeholder="Select"
                    [(ngModel)]="filter.value" optionLabel="name" optionValue="code"></p-dropdown>
                </div>
                <div *ngSwitchCase="'CALENDAR'">
                  <p-calendar class="im-input-calendar mw-100 datePicker-emp" [(ngModel)]="filter.value"
                  yearRange="1900:{{currentYear}}" monthNavigator="true" yearNavigator="true" inputId="icon" [showIcon]="true" dateFormat="mm/dd/yy"
                    placeholder="MM/DD/YYYY"></p-calendar>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <button type="submit" (click)="onFilter()" class="btn btn-primary mr-3">Submit</button>
            <button type="button" class="btn btn-light" (click)="onClear()">Clear</button>
          </div>
        </div>
      </div>
    </ng-template>
  </p-overlayPanel>
  <button type="text" id="targetButton" pButton icon="pi pi-filter"
    [ngClass]="{'visibilityHidden': !(filters && filters.length > 0)}" iconPos="right" title="Filter" label="Filter"
    (click)="op.toggle($event)" class="fb-filter-btn"></button>
    <!--View By-->
    <p-overlayPanel #vb [appendTo]="'body'">
      <ng-template pTemplate="content">
        <div class="fb-viewby-container">
          <ng-container *ngFor="let item of dateFilter">
            <div class="row date-cal" *ngIf="item.type === 'datepicker' && viewBy==='weekly'" >
              <div class="col-6 mt-1 form-group">
                <label class="label-cls d-block">From</label>
                <p-calendar [(ngModel)]="item.from" [showIcon]="true"
                [minDate]="minWeekStart" 
                [maxDate]="maxWeekStart" class="date-filter-calendar" (onSelect)="clearViewByTo($event, item)"
                  dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY" class="im-input-calendar mw-100 datePicker-emp"></p-calendar>
              </div>            
              <div class="col-6 mt-1 form-group">
                <label class="label-cls d-block">To</label>
                <p-calendar [(ngModel)]="item.to" [disabled]="!item.from"
                  [showIcon]="true" [minDate]="item.from" [maxDate]="maxWeekStart"                 
                  class="date-filter-calendar" dateFormat="mm/dd/yy" (onSelect)="onSelectDate($event, item)"
                  placeholder="MM/DD/YYYY" class="im-input-calendar mw-100 datePicker-emp"></p-calendar>
              </div>
              <div *ngIf="item.type === 'text'" class="col-12 form-group" style="padding-left: 25px;" 
                 (click)="onClickDropdownItem($event, item)" [ngClass]="{'selected': item.selected==true}">
                <span class="date-filter-item">{{ item.label }}</span>
              </div>
            </div>
            <div class="row date-item" *ngIf="item.type != 'datepicker'" >              
              <div *ngIf="item.type === 'text'" class="col-12 form-group" style="padding-left: 25px;" 
                 (click)="onClickDropdownItem($event, item)" [ngClass]="{'selected': item.selected==true}">
                <span class="date-filter-item">{{ item.label }}</span>
              </div>
            </div>
          </ng-container>          
        </div>
        <div class="row mt-2">
          <div class="col-12">
              <button type="submit" (click)="onViewBy()" class="btn btn-primary mr-3">Submit</button>
             <button type="button" class="btn btn-light" (click)="onClearViewBy()">Clear</button>
          </div>
        </div>       
      </ng-template>      
    </p-overlayPanel>   
  
    <button  id="viewbyBtn" pButton  icon="pi pi-angle-down"  iconPos="right"
    [ngClass]="{'visibilityHidden': !(viewBy)}" title="viewby" 
    (click)="vb.toggle($event)" class="ml-2 fb-filter-btn" label="&nbsp;"><span class="p-button-label">{{selectedDateFilter ? selectedDateFilter.label : 'View By'}}</span></button>
    <!--EO View By-->   
</div>
<div class="text-center empty-container" *ngIf="!isLoading && tableValue.length === 0 && emptyMsgFlag && !popupMessageFlag">
  <ng-container *ngFor="let action of displayMessageAction.actions">
    <div class="message-container">
      {{ action.emptyMsg }}
    </div>
    <button type="button" (click)="handleEmptyRedirectAction(action.redirectBtnName)" class="btn btn-primary mr-3 mt-3 action-btn">
      {{ action.redirectBtnName }} 
    </button>
  </ng-container>
</div>
<div class="container-fluid mt-1 background-on-master-list-padding" *ngIf="isLoading || tableValue.length > 0 || !emptyMsgFlag || popupMessageFlag">
  <div class="background-on-master-list" *ngIf="!isAccordion">
    <p-table [value]="tableValue" [columns]="defaultColumns" styleClass="p-datatable-fb-forms">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th scope="col" *ngIf="multiselectactionsflag && totalRecords > 0"> 
            <input type="checkbox" class="custom-checkbox" (change)="selectAll($event)" [checked]="isAllSelected()" />
          </th>
          <th scope="col" *ngFor="let col of columns">
            {{ col.displayName }}
          </th>
          <th scope="col" *ngIf="actionsInfo?.actionsflag" class="action-col-width">Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
          <td *ngIf="multiselectactionsflag">
            <input type="checkbox" class="custom-checkbox" [(ngModel)]="rowData.selected" (change)="onCheckboxChange(rowData)" />
          </td>
          <td *ngFor="let col of columns"> 
            <ng-container *ngIf="col.displayName === 'Resume' || col.displayName === 'Documents'; else default">
              <a (click)="download(rowData)" class="pdf-link">
                <img src="assets/Doc.svg" alt="PDF" class="pdf-icon">
              </a>
              <!-- <a href="javascript:void(0)" (click)="download(rowData)">{{ rowData[col.displayName] ? "Download" : '--' }}</a> -->
            </ng-container>
            <ng-template #default>
              <ng-container *ngIf='isNumber(rowData[col.displayName]); else checkHTML'>
                {{ rowData[col.displayName] ? rowData[col.displayName] : '--' }}
              </ng-container>
              <ng-template #checkHTML>
                <ng-container *ngIf="isHTMLTags(rowData[col.displayName]); else defaultCell">
                  <div [innerHTML]="rowData[col.displayName]"></div>
                </ng-container>
                
                <ng-template #defaultCell>
                  {{ rowData[col.displayName] ? rowData[col.displayName] : '--' }}
                </ng-template>
              </ng-template>
            </ng-template>
            <!-- {{ rowData[col.displayName] ? rowData[col.displayName] : '--' }} -->
          </td>
          <td *ngIf="actionsInfo?.actionsflag" class="action-col-width">
            <mat-icon class="mr-1 icn settingsBorder" [matMenuTriggerFor]="menu">
              <mat-icon>settings</mat-icon>
              <mat-icon>keyboard_arrow_down</mat-icon>
            </mat-icon>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="handleEdit(rowData)" *ngIf="rowData['showEditOption']">
                Edit</button>
              <!--Edit Profile-->
              <button mat-menu-item (click)="handleEditProfile(rowData)"  *ngIf="rowData['showProfileOption']">
                Edit Profile</button>
              <!--EO Edit Profile-->
              <button mat-menu-item (click)="handleDelete(rowData)" *ngIf="rowData['showDeleteOption']">
                Delete</button>
              <ng-container *ngIf="actionsInfo?.actions?.redirect">
                <ng-container *ngFor="let item of redirectList; let j = index;">
                  <button mat-menu-item (click)="handleRedirect(item, rowData)"
                    *ngIf="rowData['showRedirectOption'][j]">
                    {{ item.displayName }}</button>
                </ng-container>
              </ng-container>        
              <ng-container *ngIf="actionsInfo?.actions?.custom">
                <ng-container *ngFor="let item of customList; let k = index;">
                  <button mat-menu-item (click)="handleCustom(rowData, item.uniqueKey)"
                    *ngIf="rowData['showCustomOption'][k]">
                    {{ item.displayName }}</button>
                </ng-container>
              </ng-container>        
            </mat-menu>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="actionsInfo?.actionsflag ? (defaultColumns.length + 1) : defaultColumns.length"
            class="text-center">No data available.</td>
        </tr>
      </ng-template>
    </p-table>
    <div class="mt-3" *ngIf="multiselectactionsflag && hasVisibleActions && totalRecords > 0">
      <ng-container *ngFor="let action of multiActionBtns">
        <button *ngIf="action.isVisible" 
                type="button" 
                (click)="handleMultiAction(action.btnName)"
                class="btn btn-primary mr-3 action-btn" 
                [disabled]="selectedRowsData.length === 0">
          {{ action.btnName }}
        </button>
      </ng-container>
    </div>
    
    
    <p-paginator *ngIf="totalRecords > 0" [rows]="itemsPerPage" [totalRecords]="totalRecords"
      [rowsPerPageOptions]="[10, 25, 50]" (onPageChange)="onPageChange($event)"
      (onPageSizeChange)="onPageSizeChange($event)"></p-paginator>
  </div>
  <div class="background-on-master-list fb-accordion-bg-white p-3" *ngIf="isAccordion">
    <div *ngFor="let accordion of accordions; let i = index" class="accordion"
      [ngClass]="{'pb-3': accordion.openAccordion}">
      <button (click)="accordion.openAccordion = !accordion.openAccordion" class="accordion-button" type="button">
        <span class="pi"
          [ngClass]="{'pi-angle-down': !accordion.openAccordion, 'pi-angle-up': accordion.openAccordion}"></span>
        {{ accordion.title }}
        <div class="status-count" *ngIf="accordion.statusLegendArray.length > 0">
          <span *ngFor="let statusLegend of accordion.statusLegendArray"
            [ngClass]="{'custom-font-weight-normal': statusLegend.name !== 'Total' }">{{ statusLegend.name }}: {{
            statusLegend.count }}</span>
        </div>
      </button>
      <div [ngClass]="{'panel': true, 'panel-open': accordion.openAccordion}">
        <div>
          <p-table [value]="accordion.tableValue" [columns]="defaultColumns"
            styleClass="p-datatable-fb-forms alternate-colour">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th scope="col" *ngFor="let col of columns">
                  {{ col.displayName }}
                </th>
                <th scope="col" *ngIf="actionsInfo?.actionsflag" class="action-col-width">Action</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr>
                <td *ngFor="let col of columns">
                  <!-- {{ rowData[col.displayName] }} -->
                  <ng-container *ngIf="col.displayName === 'Resume'; else defaultCell">
                    <a href="javascript:void(0)" (click)="download(rowData)">{{ rowData[col.displayName] ? "Download" : '--' }}</a>
                  </ng-container>
                  <ng-template #defaultCell>
                  {{ rowData[col.displayName] }}
                  </ng-template>
                </td>
                <td *ngIf="actionsInfo?.actionsflag" class="action-col-width">
                  <mat-icon class="mr-1 icn settingsBorder" [matMenuTriggerFor]="menu">
                    <mat-icon>settings</mat-icon>
                    <mat-icon>keyboard_arrow_down</mat-icon>
                  </mat-icon>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="handleEdit(rowData)" *ngIf="actionsInfo?.actions?.edit">
                      Edit</button>
                    <button mat-menu-item (click)="handleDelete(rowData)" *ngIf="actionsInfo?.actions?.delete">
                      Delete</button>
                    <ng-template [ngIf]="actionsInfo?.actions?.redirect">
                      <button mat-menu-item (click)="handleRedirect(item, rowData)" *ngFor="let item of redirectList">
                        {{ item.displayName }}</button>
                    </ng-template>
                  </mat-menu>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="actionsInfo?.actionsflag ? (defaultColumns.length + 1) : defaultColumns.length"
                  class="text-center">No data available.</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
    <div class="text-center" *ngIf="accordions.length === 0">
      No data available.
    </div>
  </div>
</div>
<p-confirmDialog header="Delete"></p-confirmDialog>